export default __webpack_public_path__ + "static/media/imagen-background-contact.321b4878.jpeg";